import * as React from 'react';
interface IAdd {
    style?: {}; // inline style obj
    color?: string; // #000000
}
const Add: React.FC<IAdd> = (props) => {
    const { color } = props;
    return (
        <svg
            width={25}
            height={25}
            viewBox="0 0 30 30"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <defs>
                <path
                    id="add__a"
                    d="M15.995 14.007V9.375H14.01v4.632H9.375v1.986h4.634v4.632h1.986v-4.632h4.63v-1.986z"
                />
            </defs>
            <g transform="translate(-561 -1)" fill="none" fillRule="evenodd">
                <circle stroke={color} strokeWidth={2} cx={576} cy={16} r={14} />
                <g transform="translate(561 1)">
                    <mask id="add__b" fill="#fff">
                        <use xlinkHref="#add__a" />
                    </mask>
                    <use fill={color} fillRule="nonzero" xlinkHref="#add__a" />
                    <g mask="url(#add__b)">
                        <path d="M0 0h30v30H0z" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Add;
